var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsulting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chrome Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SideNav-Revised",
    transform: "translate(-27.000000, -887.000000)",
    fill: "#F16334",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 885.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.200000, 2.400000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 4.800000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.482484,-0.09054 C4.35149205,-0.09054 2.624364,1.63745924 2.624364,3.76866 C2.624364,5.89975627 4.35138773,7.62678 6.482484,7.62678 C8.61368476,7.62678 10.341684,5.89965195 10.341684,3.76866 C10.341684,1.63756373 8.61358027,-0.09054 6.482484,-0.09054 Z M6.482484,1.70946 C7.61946773,1.70946 8.541684,2.63167627 8.541684,3.76866 C8.541684,4.90533614 7.61977535,5.82678 6.482484,5.82678 C5.34550027,5.82678 4.424364,4.90564373 4.424364,3.76866 C4.424364,2.63136865 5.34580786,1.70946 6.482484,1.70946 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.482268,6.170544 C10.0236756,6.170544 12.9115241,8.97164832 13.050288,12.4784068 L13.055508,12.742704 L13.055508,13.850664 L11.255508,13.850664 L11.255508,12.742704 C11.255508,10.1076198 9.11815119,7.970544 6.482268,7.970544 C3.92717105,7.970544 1.84009331,9.98019457 1.71595003,12.5045804 L1.710108,12.742704 L1.710108,13.850664 L-0.089892,13.850664 L-0.089892,12.742704 C-0.089892,9.11364773 2.85321173,6.170544 6.482268,6.170544 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.35868,-0.09054 C13.2268259,-0.09054 11.49948,1.63724144 11.49948,3.76866 C11.49948,5.89997402 13.2267215,7.62678 15.35868,7.62678 C17.4890185,7.62678 19.2168,5.89943415 19.2168,3.76866 C19.2168,1.63778158 17.4889141,-0.09054 15.35868,-0.09054 Z M15.35868,1.70946 C16.4946999,1.70946 17.4168,2.63179255 17.4168,3.76866 C17.4168,4.90521998 16.4950076,5.82678 15.35868,5.82678 C14.2207324,5.82678 13.29948,4.90575984 13.29948,3.76866 C13.29948,2.63125242 14.2210401,1.70946 15.35868,1.70946 Z",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.358032,6.170328 C18.8994791,6.170328 21.786262,8.97147081 21.9249739,12.4791965 L21.930192,12.743568 L21.930192,13.850448 L20.130192,13.850448 L20.130192,12.743568 C20.130192,10.1072852 17.9937967,7.970328 15.358032,7.970328 C13.9763678,7.970328 12.694327,8.55951319 11.7974239,9.5649602 L11.6232631,9.77154852 L10.2152009,8.65022748 C11.4537592,7.09494851 13.3301752,6.170328 15.358032,6.170328 Z",
    id: "Stroke-7"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    points: "14.4 -0.3 14.4 1.5 7.2 1.5 7.2 -0.3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.f3e0f4fa66b8165b787797d49cceeb6b.svg";
export { ForwardRef as ReactComponent };